import PersonsDuplicatesMergeModalView from "./personDuplicatesMergeModal.html";


angular.module("persons")

    .controller("PersonsDuplicatesListCtrl", ['datasetsService', 'notificationService', 'treeService', '$sce', '$uibModal', 'LoginService', '$stateParams', '$filter', '$rootScope', '$scope', '$http', '$interval', '$q', 'Restangular', 'gridService', 'modalService', '$translate', '$window', '$state', 'generateDocumentService', 'uiGridTreeViewConstants', 'logService',
        function (datasetsService, notificationService, treeService, $sce, $uibModal, LoginService, $stateParams, $filter, $rootScope, $scope, $http, $interval, $q, Restangular, gridService, modalService, $translate, $window, $state, generateDocumentService, uiGridTreeViewConstants, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");

            //Reseteamos los filtros del buscador
            $scope.options = {dni: "false", show_hidden: false};
            $scope.duplicatesFilter = { name: "" };
            let filter = false;

            $scope.mergeGroup = [];

            $scope.duplicate_string = $filter('translate')('persons.duplicate_string');

            // Breadcrumbs
            $rootScope.title = $filter('translate')('persons.duplicates_title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('persons.duplicates_list') }
            ];

            $scope.parsePersonType = function (person_type) {

                var result = "";

                if (person_type == "authority") {
                    result = $filter('translate')('persons.title');
                }
                if (person_type === "anonymous") {
                    result = $filter('translate')('persons.title_anonymous');
                } else if (person_type === "imported") {
                    result = $filter('translate')('persons.title_imported');
                } else if (person_type === "enrolled") {
                    result = $filter('translate')('inscriptions_forms.inscripted');
                }

                return result;

            };

            var trusted = {};

            $scope.getPopoverContent = function (html) {
                return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
            };

            //Definimos el grid
            $scope.gridOptions = {
                exporterMenuCsv: false,
                enableFiltering: false,
                enableGridMenu: true,

                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                pdfTitle: $rootScope.title,
                exporterSuppressColumns: ["image_id"], //la eliminamos porque no funciona con la url, probar con base64 si se quiere.
                exporterOlderExcelCompatibility: true,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, exporterSuppressExport: true, width: 80 },
                    { name: 'id_ext', visible: false, exporterSuppressExport: true, width: 80 },
                    {
                        name: 'is_active', displayName: " ", visible: true, exporterSuppressExport: true, width: 30, enableHiding: false,
                        //cellTemplate: '<div class="ui-grid-cell-contents">row.entity.is_active<span class="label label-danger" ng-show="!row.entity.is_active">Activo<span><span class="label label-primary" ng-show="row.entity.is_active">a<span></div>'
                        cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\" ng-if=\"!row.entity.is_group\">" +
                            "<span ng-if=\"!row.entity.is_active\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "<span ng-if=\"row.entity.is_active\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "</div>"
                    },
                    {
                        customFormatFn: function (value) {
                            if (value.contains("<br>")) value = value.replaceAll("<br>", "\n");
                            return value;
                        },
                        name: 'position_for_anonymous', displayName: $filter('translate')('persons.active_positions'),
                        enableFiltering: false, enableSorting: false, width: '*', enableHiding: true, visible: $stateParams.person_type === 'anonymous',
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.FK_persons_positions_persons.length == 0">-- ' + $filter('translate')('persons.no_position') + ' -- </span><span ng-if="row.entity.FK_persons_positions_persons.length > 1"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.position_and_group_name)" popover-append-to-body="true">-- ' + $filter('translate')('persons.many_positions') + ' -- </a></span><span ng-if="row.entity.FK_persons_positions_persons.length == 1"><a class="aColorGrey margin-right-5" ng-click="$event.stopPropagation();grid.appScope.composeUiPopover(row.entity.groupId)" popover-placement="right" popover-trigger="click outsideClick" uib-popover-html="grid.appScope.valuePopover" popover-append-to-body="true"><i class="fa fa-sitemap"></i></a><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="row.entity.position_and_group_name" popover-append-to-body="true"><span ng-if="row.entity.FK_persons_positions_persons[0].to_date != null">({{ row.entity.FK_persons_positions_persons[0].to_date | toLocalDate | date: \'dd/MM/yyyy\' }}) </span>{{row.entity.position_and_group_name}}</a></span></div>',
                    },
                    { name: 'name', displayName: $filter('translate')('persons.name'), enableFiltering: true, enableHiding: false, minWidth: 250 },
                    { name: 'surname', displayName: $filter('translate')('persons.surname'), enableFiltering: true, enableHiding: true, minWidth: 80, maxWidth: 150 },
                    { name: 'lastname', displayName: $filter('translate')('persons.lastname'), enableFiltering: true, enableHiding: true, minWidth: 60, maxWidth: 150 },
                    {
                        name: 'person_type', displayName: $filter('translate')('persons.type'), enableFiltering: true, enableHiding: true, minWidth: 60, maxWidth: 150,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.parsePersonType(row.entity.person_type)}}</div>'
                    },
                    {
                        customFormatFn: function (value) {
                            if (value.contains("<br>")) value = value.replaceAll("<br>", "\n");
                            return value;
                        },
                        name: 'position_and_group_name', displayName: $filter('translate')('persons.active_positions'),
                        enableFiltering: false, enableSorting: false, width: '*', enableHiding: true, visible: $stateParams.person_type !== 'anonymous' && $stateParams.person_type !== 'enrolled',
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.FK_persons_positions_persons.length == 0">-- ' + $filter('translate')('persons.no_position') + ' -- </span><span ng-if="row.entity.FK_persons_positions_persons.length > 1"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.position_and_group_name)" popover-append-to-body="true">-- ' + $filter('translate')('persons.many_positions') + ' -- </a></span><span ng-if="row.entity.FK_persons_positions_persons.length == 1"><a class="aColorGrey margin-right-5" ng-click="$event.stopPropagation();grid.appScope.composeUiPopover(row.entity.groupId)" popover-placement="right" popover-trigger="click outsideClick" uib-popover-html="grid.appScope.valuePopover" popover-append-to-body="true"><i class="fa fa-sitemap"></i></a><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="row.entity.position_and_group_name" popover-append-to-body="true"><span ng-if="row.entity.FK_persons_positions_persons[0].to_date != null">({{ row.entity.FK_persons_positions_persons[0].to_date | toLocalDate | date: \'dd/MM/yyyy\' }}) </span>{{row.entity.position_and_group_name}}</a></span></div>',
                    },
                    {
                        name: '  ', width: 100, enableFiltering: true, enableHiding: false, visible: true,
                        cellTemplate: `<div class="ui-grid-cell-contents ng-binding ng-scope"><span ng-if="row.entity.duplicate_of" style="color:#1ab394" title="{{grid.appScope.duplicate_string}}"><i class="fas fa-user-tag"></i></span></div>`,
                    },
                    {
                        name: ' ', width: 350, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('persons.hide_from_duplicates'), action: 'ng-click="grid.appScope.toggleHidden(row.entity)" ng-if="!row.entity.is_group && !row.entity.hide_from_duplicates"', cssIconClass: "fas fa-eye" },
                            { title: $filter('translate')('persons.show_to_duplicates'), action: 'ng-click="grid.appScope.toggleHidden(row.entity)" ng-if="!row.entity.is_group && row.entity.hide_from_duplicates"', cssIconClass: "fas fa-eye-slash"},
                            { title: $filter('translate')('persons.edit'), action: 'ng-click="grid.appScope.goToEdit(row.entity)" ng-if="!row.entity.is_group"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('persons.duplicates.merge'), action: 'ng-click="grid.appScope.goToMerge(row.entity)" ng-if="!row.entity.is_group && !row.entity.duplicate_of"', cssIconClass: "fa fa-people-arrows" },
                            { title: $filter('translate')('persons.duplicates.unmark'), action: 'ng-click="grid.appScope.unmark(row.entity)"   ng-if="!row.entity.is_group && row.entity.duplicate_of"', cssIconClass: "fa fa-undo" },
                            { title: $filter('translate')('persons.button_delete'), action: 'ng-click="grid.appScope.DeleteDialog(row.entity.id,row.entity.name, row.entity.surname);" ng-if="grid.appScope.allowWrite && !row.entity.is_group" && (grid.appScope.allowDelete || (grid.appScope.allowDiscard && (grid.appScope.person_type==\'anonymous\' || grid.appScope.person_type==\'imported\' || grid.appScope.person_type==\'enrolled\')))" ', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {

                    var deferred = $q.defer();
                    options = $scope.options;

                    var firstRow = ($scope.gridOptions.paginationCurrentPage - 1) * $scope.gridOptions.paginationPageSize;

                    Restangular.all('Persons/Duplicates').getList(options).then(function (results) {
                        var data: any = [];

                        if ($scope.options.dni != "true") {

                            // Hacemos los grupos a mano

                            let persons = [];
                            let personsList = [];
                            results.forEach(function (group) {
                                persons = [...group, ...persons];
                            });
                            persons.forEach(function (person) {
                                person.key = person.fullnameNormalized;
                            });
                            let uniqueNames = [...new Set(persons.map(c => c.key))];

                            uniqueNames.forEach(function (unique) {
                                let followers = persons.filter(c => c.key == unique);
                                personsList = [...personsList, followers];
                                results = personsList;
                            })

                        }

                        let results2;

                        if ($scope.duplicatesFilter.name != "" && filter == true) {
                            logService.debug(results[0][0].name + results[0][0].surname + results[0][0].lastname)
                            results2 = results.filter((d) => d.some((i) => `${i.name}${i.surname}${i.lastname}`.toLowerCase().includes($scope.duplicatesFilter.name.toLowerCase())))
                               
                            results2 = results2.slice(firstRow, firstRow + $scope.gridOptions.paginationPageSize);
                        } else {
                            results2 = results.slice(firstRow, firstRow + $scope.gridOptions.paginationPageSize);
                        }

                        results2.forEach(result => {
                            let group = {
                                name: $scope.options.dni == "true" ? `Duplicados DNI: ${result[0].num_identification}` : `Duplicados de ${result[0].name} ${result[0].surname}`,
                                $$treeLevel: 0,
                                is_group: true
                            };

                            // Asignamos una Key para reconocer posteriormente a los elementos que forman parte del mismo grupo. 
                            let num = 0;
                            result.forEach(r => {
                                r.key = group.name;
                                r.identifier = num;
                                num++;
                            });

                            data = [...data, group, ...result];

                        });

                        filter = false;
                        logService.debug(data)
                        data.totalRows = results.length;

                        $scope.duplicatesData = data;
                        deferred.resolve(data);

                    });

                    return deferred.promise;

                }

            };

            $scope.search = function () {
                if (angular.isDefined($scope.gridOptions.loadData)) {
                    filter = true;
                    $scope.gridOptions.loadData(false);
                }
            };

            $scope.goToEdit = function (rowEntity) {

                // $state.go("persons.edit", { person_type: rowEntity.person_type, id: rowEntity.id, coming_from_duplicates: true });

                var url = $state.href("persons.edit", { person_type: rowEntity.person_type, id: rowEntity.id, coming_from_duplicates: true });
                $window.open(url, '_blank');

            };


            $scope.goToMerge = function (person) {

                $scope.mergeGroup = $scope.duplicatesData.filter((d) => d.key == person.key && d.duplicate_of == null);
                $scope.mergeGroup[person.identifier].is_main = "true";
                $scope.mergeGroup[person.identifier].selected = true;

               $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: PersonsDuplicatesMergeModalView,
                    controller: "PersonsDuplicatesMergeCtrl",
                    size: 'lg',
                    scope: $scope,
                    resolve: {}

                });

            };

            $scope.unmark = function (person) {
                person.duplicate_of = null;
                Restangular.one('Persons', person.id).get().then(function (result) {
                    person = result;
                    person.duplicate_of = null;
                    person.put().then(function (result) {
                        if (typeof (result.id) != "undefined") {
                            toastr.success($filter('translate')('persons.duplicates_unmarked_success'));
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                });
            };

            $scope.toggleHidden = function (person) {
 
                if (!person.hide_from_duplicates == true) {
                    person.hide_from_duplicates = true
                } else {
                    person.hide_from_duplicates = null
                }
                person.duplicate_of = null;

                Restangular.one('Persons', person.id).get().then(function (result) {
                    person = result;
                    person.duplicate_of = null;
                    if (!person.hide_from_duplicates == true) {
                        person.hide_from_duplicates = true
                    } else {
                        person.hide_from_duplicates = null
                    }
                    person.put();
                });

            };

            $scope.DeleteDialog = function (id, name, surname) {
                $scope.id = id;
                $scope.name = name + " " + surname;
                modalService.confirm({
                    title: $filter('translate')('persons.button_delete'),
                    message: $filter('translate')('persons.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Persons', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('persons.delete_success'));
                            $scope.gridOptions.loadData(false);
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                            alert("Error al borrar")
                        });
                    }
                });
            };

        }])

    .controller("PersonsDuplicatesMergeCtrl", ['$filter', '$scope', 'Restangular', 'logService',
        function ( $filter, $scope, Restangular, logService) {


            $scope.changeMain = function (person) {
                $scope.mergeGroup.forEach(p => p.is_main = "false");
                if (person.is_main != "true") {
                    person.is_main = "true"
                    person.selected = true
                }
            };

            $scope.onCancel = function () {
                $scope.mergeGroup.forEach(p => {
                    p.is_main = "false";
                    p.selected = false;
                });
               $scope.$modalInstance.dismiss('cancel');
            };

            $scope.merge = function () {

               let dataToSend = $scope.mergeGroup.filter((m) => m.selected == true && m.is_main != "true");
               logService.debug(dataToSend);

                
                if (dataToSend.length > 0) {

                    let mainPerson = $scope.mergeGroup.filter((m) => m.is_main == "true")[0];
                    logService.debug(mainPerson)
                    logService.debug(dataToSend)


                    dataToSend.forEach(person => {

                        person.duplicate_of = mainPerson.id;

                        // Hay que hacer el Get porque el person no esta 'Restangulariced' y hacer directamente person.put() no funcionaría
                        Restangular.one('Persons', person.id).get().then(function (result) {
                            person = result;
                            person.duplicate_of = mainPerson.id;
                            person.put().then(function (result) {
                                if (typeof (result.id) != "undefined") {
                                    toastr.success($filter('translate')('persons.duplicates_marked_success'));
                                } else {
                                    $scope.errorMessage = result.message;
                                }

                            });
                        });
                      
                    });

                    logService.debug(dataToSend);
                   $scope.$modalInstance.close();

                } else {
                    $scope.errorMessage = $filter('translate')('persons.too_few_duplicates') ;
                   $scope.$modalInstance.dismiss('cancel');
                };
                
            };

        }])